import { render, staticRenderFns } from "./TickCross.vue?vue&type=template&id=ac71de78&lang=pug&"
import script from "./TickCross.vue?vue&type=script&lang=ts&"
export * from "./TickCross.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports